import moment from "moment";
import UpdateStatus from "../update/Update";
import { useState, useEffect } from "react";

const SearchByNumber = ({ search, value, data }) => {

  const [hide, setHide] = useState(false);
  const [values, setValue] = useState("");
  const [info, setInfo] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  const [totals, setTotals] = useState([0, 0]); // [bookingTotal, deliveryTotal]

  const handleUpdateBooking = ({
    _id,
    billNo,
    name,
    date,
    phone,
    countryCode,
    qty,
    amount,
    status,
  }) => {
    setInfo({ _id, billNo, name, date, phone, countryCode, qty, amount, status });
    setValue("Update Booking");
    setHide(true);
  };

  const handleUpdateDelivery = ({ _id, billNo, amount, amountType, qty, date }) => {
    setInfo({ _id, billNo, amount, amountType, qty, date });
    setValue("Update Delivery");
    setHide(true);
  };

  const handleClose = () => setHide(false);

  useEffect(() => {
    if (!data?.length) return setFilteredData([]);

    const searchLower = String(search).toLowerCase();
    let bookingTotal = 0;
    let deliveryTotal = 0;

    const result = data.filter((record) => {
      if (value === "Searched By Bill No") {
        return record.billNo.toLowerCase().includes(searchLower);
      } else {
        return record.phone.includes(searchLower);
      }
    }).map((record) => {
      // Calculate deliveryTotal for each record
      let deliverySum = 0;

      if (record.deliveryDetails?.length > 0) {
        record.deliveryDetails.forEach((delivery) => {
          deliverySum += delivery.amount;
          deliveryTotal += delivery.amount;
        });
      }

      bookingTotal += record.amount;
      record.deliveryTotal = deliverySum;

      return record;
    });

    setFilteredData(result);
    setTotals([bookingTotal, deliveryTotal]);
  }, [search, value, data]);

  return (
    <>
      {filteredData.length ? (
        <div>
          {filteredData.map((element, key) => (
            <div className="total-booking-delivery" key={key}>
              <h6 className="delivery-info-details">Booking Info</h6>
              <div className="total-bookingcontainer">
                <div
                  className="total-property"
                  onClick={() => handleUpdateBooking(element)}
                >
                  <span className="update-link">Bill No:-</span>
                </div>
                <div className="total-value">{element.billNo}</div>
                <div className="total-property">Name:-</div>
                <div className="total-value">{element.name.toUpperCase()}</div>
                <div className="total-property">Phone:-</div>
                <div className="total-value">{`${element.countryCode}-${element.phone}`}</div>
                <div className="total-property">Date:-</div>
                <div className="total-value">
                  {moment(element.date).format("DD/MM/YYYY")}
                </div>
                <div className="total-property">Quantity:-</div>
                <div className="total-value">{element.qty}</div>
                <div className="total-property">Amount:-</div>
                <div className="total-value">{element.amount}</div>

                {element.advance ? (
                  <>
                    <div className="total-property">Advance:-</div>
                    <div className="total-value">{element.advance}</div>
                    <div className="total-property">Amount-Status:-</div>
                    <div className="total-value">
                      {element.amountType?.toUpperCase()}
                    </div>
                  </>
                ) : null}

                <div className="total-property">Status:-</div>
                <div className="total-value">{element.status.toUpperCase()}</div>

                {element.deliveryDetails.length === 0 && (
                  <>
                    <div className="total-property alert-value">Alert</div>
                    <div className="total-value alert-value">{element.amount}</div>
                  </>
                )}
              </div>

              {element.deliveryDetails.length > 0 && (
                <>
                  <hr />
                  <h6 className="delivery-info-details">Delivery Info</h6>

                  {element.deliveryDetails.map((delivery, dKey) => (
                    <div className="total-delivery-container" key={dKey}>
                      <div
                        className="total-property"
                        onClick={() => handleUpdateDelivery(delivery)}
                      >
                        <span className="update-link">Bill No:-</span>
                      </div>
                      <div className="total-value">{delivery.billNo}</div>
                      <div className="total-property">Date:-</div>
                      <div className="total-value">
                        {moment(delivery.date).format("DD/MM/YYYY")}
                      </div>
                      <div className="total-property">Amount:-</div>
                      <div className="total-value">{delivery.amount}</div>
                      <div className="total-property">Amount-Status:-</div>
                      <div className="total-value">{delivery.amountType?.toUpperCase()}</div>
                    </div>
                  ))}

                  <div className="total-amount">
                    <div className="total-property">Total Booking</div>
                    <div className="total-value">{element.amount}</div>
                    <div className="total-property">Total Delivery</div>
                    <div className="total-value">{element.deliveryTotal}</div>

                    {(element.advance || 0) < element.deliveryTotal ? (
                      <>
                        <div className="total-property alert-value">Alert</div>
                        <div className="total-value alert-value">
                          {(element.amount - element.deliveryTotal) * -1}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="total-property alert-success">Alert</div>
                        <div className="total-value alert-success">
                          {element.amount - element.deliveryTotal}
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}
            </div>
          ))}

          <br />
          <hr />
          <div className="total-booking-deliveries">
            <div className="total-footer-amount">
              <div className="total-p">Total Booking</div>
              <div className="total-v">{totals[0]}</div>
              <div className="total-p">Total Delivery</div>
              <div className="total-v">{totals[1]}</div>
              {totals[0] > totals[1] ? (
                <>
                  <div className="total-p alert-value">Alert</div>
                  <div className="total-v alert-value">{totals[0] - totals[1]}</div>
                </>
              ) : (
                <>
                  <div className="total-p alert-success">Alert</div>
                  <div className="total-v alert-success">
                    {(totals[0] - totals[1]) * -1}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      ) : (
        <p style={{ color: "red" }}>
          {value === "Searched By Bill No" ?
          (
            <>
             {search ? `Oops! No records found from this Bill ${search}` : "Bill number is required" }
            </>
          ) :
          (
            <>
             {search ? `Oops! No records found from this Number ${search}` : "Mobile number is required" }
            </>
          )
          }
         
       
        </p>
      )}

      <UpdateStatus show={hide} value={values} close={handleClose} info={info} />
    </>
  );
};

export default SearchByNumber;
